const LOAD_POPULAR_CITY_LIST_URL = '/geo/city/data/load-popular-list';
const FIND_CITY_URL = '/geo/city/data/find-for-select';

const API_POPULAR_CITIES_NAME = 'apiPopularCities';

export {
  LOAD_POPULAR_CITY_LIST_URL,
  FIND_CITY_URL,

  API_POPULAR_CITIES_NAME,
};
